import api from './api'

export interface User {
  id: string
  firstName: string
  lastName: string
  email: string
  phone?: string
  role: string
  college?: {
    id: string
    name: string
    code: string
  }
  isActive: boolean
  lastLogin?: string
  createdAt: string
  updatedAt: string
}

export interface CreateUserRequest {
  username: string
  email: string
  password: string
  firstName: string
  lastName: string
  phone?: string
  role: string
  collegeId?: string
}

export interface UpdateUserRequest {
  username?: string
  email?: string
  firstName?: string
  lastName?: string
  phone?: string
  isActive?: boolean
}

export interface UserQueryParams {
  page?: number
  limit?: number
  search?: string
  role?: string
  collegeId?: string
  isActive?: boolean
  sortBy?: string
  sortOrder?: 'ASC' | 'DESC'
}

export interface PaginatedUsersResponse {
  success: boolean
  message: string
  data: User[]
  meta: {
    total: number
    page: number
    limit: number
    totalPages: number
  }
}

export interface UserResponse {
  success: boolean
  message: string
  data: User
}

class UsersService {
  async getUsers(params?: UserQueryParams): Promise<PaginatedUsersResponse> {
    const response = await api.get('/users', { params })
    return response.data
  }

  async getUserById(id: string): Promise<UserResponse> {
    const response = await api.get(`/users/${id}`)
    return response.data
  }

  async createUser(userData: CreateUserRequest): Promise<UserResponse> {
    const response = await api.post('/users', userData)
    return response.data
  }

  async updateUser(id: string, userData: UpdateUserRequest): Promise<UserResponse> {
    const response = await api.put(`/users/${id}`, userData)
    return response.data
  }

  async deleteUser(id: string): Promise<{ success: boolean; message: string }> {
    const response = await api.delete(`/users/${id}`)
    return response.data
  }

  async getUserStats(): Promise<{
    total: number
    active: number
    byRole: Record<string, number>
  }> {
    const response = await api.get('/users/stats')
    return response.data.data
  }
}

export const usersService = new UsersService()
export default usersService
